import { handleError, normalize } from "../utils/normalize";
import initialState from "./initialState";

function reducer(state, action) {
  try {
    const payload = action.payload;
    switch (action.type) {
      case 'ERROR': {
        return {
          ...state,
          errors: handleError(state.errors, payload, 'app'),
        };
      }
      case 'ERROR_UP': {
        return { ...state, all_errors: normalize(state.all_errors, payload) };
      }

      case 'CLEAR_ERRORS': {
        return { ...state, all_errors: { byID: {}, allIDs: [] } };
      }

      case 'MENU_ADD': {
        return { ...state, menus: [...state.menus, { ...payload }] };
      }
      case 'MENU_REMOVE': {
        const newState = {
          ...state,
          menus: state.menus.filter((m) => m.name != payload.name),
        };
        return newState;
      }

      case 'ADD_API': {
        return { ...state, apis: [...state.apis, payload] };
      }

      case 'REMOVE_API': {
        return { ...state, apis: state.apis.filter((api) => api != payload) };
      }

      case 'USER_INFO': {
        return {
          ...state,
          user: payload,
        };
      }

      case 'BADGE': {
        return {
          ...state,
          badges: { ...state.badges, [payload.key]: payload.value },
        };
      }

      case 'HIGHLIGHT': {
        return {
          ...state,
          highlights: { ...state.highlights, [payload.key]: payload.value },
        };
      }

      case 'CONSOLE': {
        return {
          ...state,
          console: { ...state.console, display: payload.display },
        };
      }

      case 'REFRESH_DATA':
        return { ...state, refreshKey: state.refreshKey + 1 };
      case 'FETCH_OPERATION_COMPLETE':
        return {
          ...state,
          operations: normalize(state.operations, action.payload, [
            {
              name: 'accounts',
              key: ['compte'],
            },
            {
              name: 'years',
              key: ['year'],
            },
          ]),
        };

      case 'LOG_STATE':
        console.log(state);
        return state;

      default:
        throw new Error(
          `[${action.type}] is unknown in App Reducer. Did you returned a new state ?`
        );
    }
  } catch (err) {
    return {
      ...state,
      errors: handleError(state.errors, err, "app"),
    };
  }
}

export default reducer;
